export const SET_USERS_LOADED = "SET_USERS_LOADED";

export const setUsersLoaded = (usersLoaded: boolean) => {
  return {
    usersLoaded,
    // tslint:disable-next-line:object-literal-sort-keys
    type: SET_USERS_LOADED
  };
};
